// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--UIrHG","toolbar":"toolbar--uCZgA","toolbar-left":"toolbar-left--dfZWd","subTitle":"subTitle--xtbI8"};